import Cookies from 'js-cookie'

$(document).ready(function () {
  var save_menu_url = '/save_menu/'

  /* Saves the new menu state in user prefs. */
  $.fn.saveMenu = function (action) {
    var csrftoken = Cookies.get('csrftoken')
    $.ajaxSetup({
      beforeSend: function (xhr, settings) {
        xhr.setRequestHeader('X-CSRFToken', csrftoken)
      }
    })
    $.ajax({
      url: save_menu_url,
      type: 'POST',
      data: { menu: $(this).attr('id'), action: action }
    })
  }

  /* Freezes a dropdown menu so it can't be closed. */
  $.fn.freezeDropdown = function () {
    $(this).data('closable', false)
    $(this).on({
      'hide.bs.dropdown': function (e) {
        e.stopPropagation()
        return $(this).data('closable')
      }
    })
  }

  /* Declare dropdowns events. */
  $('.dropdown').on({
    'shown.bs.dropdown': function () {
      $(this).freezeDropdown()
      $(this).saveMenu('add')
    },
    'hidden.bs.dropdown': function () {
      $(this).saveMenu('delete')
    }
  })

  /* Freeze dropdowned opened when DOM is loaded (in user prefs). */
  $('.dropdown.open').each(function (i) {
    $(this).freezeDropdown()
  })

  /* Unfreeze dropdown by clicking on their specific link. */
  $('.dropdown .toggle').on('click', function () {
    $(this).parent().data('closable', true)
  })
})
